/* Imports */
import React, { useState } from "react"
import { Grid, CardAction } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const CardActionPage = () => {
    const [isLiked, setIsLiked] = useState(false)
    const handleLike = () => setIsLiked(!isLiked)

    const items = [
        {
            title: "Portrait",
            content: (
                <Grid col={2} gap="s">
                    <CardAction
                        title="Title"
                        src="/images/pic-card.jpg"
                        alt="Card"
                        rating={4.2}
                        content="Content"
                        buttonText="Button"
                        orientation="portrait"
                        onClickLike={handleLike}
                        isLikedChecked={isLiked}
                    />
                </Grid>
            ),
            code: 'const [isLiked, setIsLiked] = useState(false)\nconst handleLike = () => setIsLiked(!isLiked)\n\n<CardAction\n    title="Title"\n    src="/images/pic-card.jpg"\n    alt="Card"\n    rating={4.2}\n    content="Content"\n    buttonText="Button"\n    orientation="portrait"\n    onClickLike={handleLike}\n    isLikedChecked={isLiked}\n/>',
        },
        {
            title: "Landscape",
            content: (
                <Grid col={2} gap="s">
                    <CardAction
                        title="Title"
                        src="/images/pic-card.jpg"
                        alt="Card"
                        rating={4.2}
                        content="Content"
                        buttonText="Button"
                        orientation="landscape"
                        onClickLike={handleLike}
                        isLikedChecked={isLiked}
                    />
                </Grid>
            ),
            code: 'const [isLiked, setIsLiked] = useState(false)\nconst handleLike = () => setIsLiked(!isLiked)\n\n<CardAction\n    title="Title"\n    src="/images/pic-card.jpg"\n    alt="Card"\n    rating={4.2}\n    content="Content"\n    buttonText="Button"\n    orientation="landscape"\n    onClickLike={handleLike}\n    isLikedChecked={isLiked}\n/>',
        },
    ]

    const propsItems = [
        {
            name: "src",
            type: "String",
            example: "/images/cover.jpg",
            required: "Yes",
        },
        {
            name: "alt",
            type: "String",
            example: "Cover",
            required: "Yes",
        },
        {
            name: "title",
            type: "String",
            example: "News",
            required: "Yes",
        },
        {
            name: "content",
            type: "String",
        },
        {
            name: "onClickLike",
            type: "Function",
        },
        {
            name: "isLikedChecked",
            type: "Boolean",
        },
        {
            name: "orientation",
            type: "String",
            example: "landscape",
            possible: '"portrait" | "landscape"',
            default: "portrait",
        },
        {
            name: "rating",
            type: "Number",
            example: "4.2",
        },
        {
            name: "buttonText",
            type: "String",
            example: "Read news",
        },
        {
            name: "buttonStyle",
            type: "String",
            example: "text",
            possible: '"plain" | "text" | "outline"',
            default: "plain",
        },
        {
            name: "buttonColor",
            type: "String",
            example: "success",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            name: "onClickButton",
            type: "Function",
        },
        {
            name: "toButton",
            type: "String",
            example: "/news",
        },
        {
            name: "iconLeftButton",
            type: "String",
            example: "send-solid",
            possible: commonProps.fajnyIcons,
        },
        {
            name: "iconRightButton",
            type: "String",
            example: "chevron-right-solid",
            possible: commonProps.fajnyIcons,
        },
        {
            name: "iconLike",
            type: "String",
            example: "heart-regular",
            possible: commonProps.fajnyIcons,
            default: "heart-solid",
        },
        {
            name: "iconLiked",
            type: "String",
            example: "heart-full-regular",
            possible: commonProps.fajnyIcons,
            default: "heart-full-solid",
        },
        {
            name: "iconRating",
            type: "String",
            example: "star-full-solid",
            possible: commonProps.fajnyIcons,
            default: "star-full-solid",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default CardActionPage
